(function () {
  'use strict';

  var PATTERN_COPY = {
    m: '1 main serving per person each day',
    main: '1 main serving per person each day',
    bm: '1 breakfast and 1 main serving per person each day',
    bmp: '1 breakfast, 1 main and 1 pudding serving per person each day',
    b2mp: '1 breakfast, 2 main and 1 pudding serving per person each day'
  };
  var CATEGORIES = ['breakfast', 'main', 'pudding'];

  function readJSON(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function number(value) { return new Intl.NumberFormat('en-GB').format(value); }
  function quantity(value, singular, plural) { return number(value) + ' ' + (value === 1 ? singular : plural || singular + 's'); }
  function money(value) { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: value % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(value / 100); }

  function initialise(root) {
    if (root.dataset.shoppingInitialised === 'true') return;
    root.dataset.shoppingInitialised = 'true';
    var core = window.PrepareHQV1714Reserve;
    var catalogue = readJSON(root, '[data-phq-shopping-catalogue]');
    var photos = readJSON(root, '[data-phq-shopping-photos]') || {};
    var form = root.querySelector('[data-phq-shopping-form]');
    var resultSection = root.querySelector('[data-phq-shopping-result-section]');
    var status = root.querySelector('[data-phq-shopping-form-status]');
    var buy = root.querySelector('[data-phq-shopping-buy]');
    var confirmation = root.querySelector('[data-phq-shopping-confirmation]');
    var builderURL = new URL(root.dataset.builderUrl, window.location.origin);
    var comparisonURL = new URL(root.dataset.comparisonUrl, window.location.origin);
    var storedPlanKey = 'preparehq.planner.v1';
    var currentRecommendation = null;
    var originalSuggestion = null;
    var commerce = readJSON(root, '[data-phq-shopping-commerce]');
    var currentRequest = null;
    var resetBar = element('div','phq-shop__customised');
    var resetLabel = element('strong','','Customised mix');
    var resetButton = element('button','','Reset to suggestion');resetButton.type='button';
    resetBar.append(resetLabel,resetButton);resetBar.hidden=true;
    root.querySelector('[data-phq-shopping-recipes]').before(resetBar);
    resetButton.addEventListener('click',function(){if(originalSuggestion){render(originalSuggestion,currentRequest);saveMixHistory(false);resetButton.blur();root.querySelector('[data-phq-shopping-result-title]').focus({preventScroll:true});}});
    function saveMixHistory(push) {
      var url=new URL(window.location.href);
      if(currentRecommendation && currentRecommendation.customised)url.searchParams.set('phq_mix',currentRecommendation.selectionToken);else url.searchParams.delete('phq_mix');
      if(currentRequest)url.searchParams.set('phq_diet',currentRequest.diet);else url.searchParams.delete('phq_diet');
      if(!currentRecommendation){
        var draftPlan=currentRequest&&core.parsePlannerState('p.'+currentRequest.people+'.'+currentRequest.months+'m.'+currentRequest.pattern);
        var draftToken=draftPlan&&draftPlan.result&&draftPlan.result.valid?core.encodePlannerState(draftPlan.result):'';
        url.searchParams.set('phq_plan',draftToken);url.searchParams.delete('phq_result');
        updateJourneyLinks(draftToken);
        try{window.sessionStorage.setItem(storedPlanKey,draftToken);}catch(error){/* The URL retains the unfinished choices. */}
      }
      window.history[push?'pushState':'replaceState'](window.history.state,'',url.href);
    }
    function changeMix(quantities,focusId) {
      var changed=window.PrepareHQShoppingEngine.customise(catalogue,currentRequest,quantities);
      if(!changed.valid){status.textContent=changed.errors.join(' ');return;}
      render(changed,currentRequest);saveMixHistory(true);
      var control=root.querySelector('[data-phq-swap="'+focusId+'"]');if(control){control.closest('details').open=true;control.focus({preventScroll:true});}
    }
    function addSwap(copy,item,result) {
      var id=item.recipeId || item.id,details=element('details','phq-swap'),summary=element('summary','','Change recipe');details.appendChild(summary);
      var label=element('label','','Choose a replacement for '+item.name),select=element('select');select.id='phq-swap-'+id;select.dataset.phqSwap=id;label.htmlFor=select.id;details.append(label,select);
      var choices=catalogue.recipes.filter(function(recipe){
        var facts=window.PrepareHQShoppingEngine.recipeFacts[recipe.id];if(!facts||recipe.category!==item.category||(currentRequest.diet==='vegetarian'&&!facts.vegetarian))return false;
        var q={};q[recipe.id]=1;return window.PrepareHQShoppingCheckout.eligibility(commerce,core.createCatalogue(catalogue).calculateBuild(q)).ok;
      });
      if(!choices.some(function(recipe){return recipe.id===id;})){var current=element('option','',item.name+' (current; enquiry only)');current.value=id;select.appendChild(current);}
      choices.forEach(function(recipe){var f=window.PrepareHQShoppingEngine.recipeFacts[recipe.id],o=element('option','',recipe.name+' · '+money(recipe.casePricePence)+' · '+(f.servingsPerTin*6)+' servings');o.value=recipe.id;select.appendChild(o);});select.value=id;
      details.appendChild(element('p','','Price and servings are per six-tin case. Keeps '+quantity(item.quantity,'case')+' when you choose.'));
      select.addEventListener('change',function(){if(select.value===id)return;var q=Object.assign({},currentRecommendation.quantities),n=q[id];delete q[id];q[select.value]=(q[select.value]||0)+n;changeMix(q,select.value);});
      var category=item.category==='dessert'?'pudding':item.category;
      if(result.extraServings[category]<0){var add=element('button','','Add a case of '+item.name);add.type='button';add.addEventListener('click',function(){var q=Object.assign({},currentRecommendation.quantities);q[id]+=1;changeMix(q,id);});details.appendChild(add);details.open=true;}
      copy.appendChild(details);
    }
    var initialURL = new URL(window.location.href);

    function emit(recommendation, request) {
      root.phqShoppingSelection = { recommendation: recommendation, request: request };
      root.dispatchEvent(new CustomEvent('phq:shopping-selection', { bubbles: true, detail: root.phqShoppingSelection }));
    }

    function readRequest() {
      return {
        people: Number(root.querySelector('[data-phq-shopping-people]').value),
        months: Number(root.querySelector('[data-phq-shopping-months]:checked').value),
        pattern: root.querySelector('[data-phq-shopping-pattern]:checked').value,
        diet: root.querySelector('[data-phq-shopping-vegetarian]').checked ? 'vegetarian' : 'mixed'
      };
    }

    function setText(selector, text) {
      var node = root.querySelector(selector);
      if (node) node.textContent = text;
    }

    function clearOldSuccessFlag() {
      var url = new URL(window.location.href);
      if (url.searchParams.has('contact_posted')) {
        url.searchParams.delete('contact_posted');
        window.history.replaceState(window.history.state, '', url.href);
      }
      if (confirmation) confirmation.hidden = true;
    }

    function validatedPlannerToken(url) {
      if (!core) return null;
      var tokens = url.searchParams.getAll('phq_plan');
      if (!tokens.length) {
        try { tokens = [window.sessionStorage.getItem(storedPlanKey) || '']; } catch (error) { return null; }
      }
      if (tokens.length !== 1) return null;
      var parsed = core.parsePlannerState(tokens[0]);
      return parsed.result && parsed.result.valid ? core.encodePlannerState(parsed.result) : null;
    }

    function restorePlannerControls(token) {
      if (!token || !core) return;
      var parsed = core.parsePlannerState(token);
      var plan = parsed.result;
      if (!plan || !plan.valid) return;
      var months = { 30: 1, 90: 3, 180: 6, 365: 12 }[plan.days];
      var pattern = { 'one-main': 'main', 'breakfast-main': 'bm', 'breakfast-main-pudding': 'bmp', 'breakfast-two-main-pudding': 'b2mp' }[plan.patternId];
      if (!months || !pattern) return;
      root.querySelector('[data-phq-shopping-people]').value = String(plan.people);
      root.querySelector('[data-phq-shopping-months][value="' + months + '"]').checked = true;
      root.querySelector('[data-phq-shopping-pattern][value="' + pattern + '"]').checked = true;
    }

    function updateJourneyLinks(planToken) {
      root.querySelectorAll('a[href]').forEach(function (link) {
        var url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin || (url.pathname !== builderURL.pathname && url.pathname !== comparisonURL.pathname)) return;
        if (planToken) url.searchParams.set('phq_plan', planToken);
        else url.searchParams.delete('phq_plan');
        link.href = url.href;
      });
    }

    function preserveNativeReturn() {
      if (!confirmation) return false;
      var url = new URL(window.location.href);
      var planToken = validatedPlannerToken(url);
      url.searchParams.delete('phq');
      url.searchParams.delete('phq_from');
      if (planToken) url.searchParams.set('phq_plan', planToken);
      else url.searchParams.delete('phq_plan');
      window.history.replaceState(window.history.state, '', url.href);
      try { window.sessionStorage.setItem(storedPlanKey, planToken || ''); } catch (error) { /* URL handoff remains usable. */ }
      updateJourneyLinks(planToken);
      restorePlannerControls(planToken);
      window.requestAnimationFrame(function () {
        var nativeForm = root.querySelector('#PrepareHQReserveEnquiryV1714');
        if (nativeForm) nativeForm.scrollIntoView({ block: 'start', behavior: 'auto' });
        confirmation.focus({ preventScroll: true });
      });
      return true;
    }

    if (!preserveNativeReturn()) {
      var foodTokens = initialURL.searchParams.getAll('phq');
      var savedFood = foodTokens.find(function (value) { return value !== ''; });
      if (savedFood) {
        var savedRoute = /^[rfe]\./.test(savedFood) ? comparisonURL : builderURL;
        var savedURL = new URL(initialURL.href);
        savedURL.pathname = savedRoute.pathname;
        savedURL.hash = 'PrepareHQReserveEnquiryV1714';
        window.location.replace(savedURL.href);
        return;
      }
      var initialPlanToken = validatedPlannerToken(initialURL);
      updateJourneyLinks(initialPlanToken);
      restorePlannerControls(initialPlanToken);
    }

    function recipeCard(item, result) {
      var card = element('li', 'phq-shop__recipe');
      var imageURL = photos[item.recipeId || item.id];
      var isIllustration = imageURL && imageURL.indexOf('phq-illustration-') !== -1;
      if (imageURL) {
        var image = element('img', 'phq-shop__recipe-photo');
        image.src = imageURL;
        image.width = 900;
        image.height = 900;
        image.loading = 'lazy';
        image.alt = item.name + (isIllustration ? ' — packaging illustration; one tin shown.' : ' tin, earlier packaging.');
        image.dataset.phqImageKind = isIllustration ? 'illustration' : 'photo';
        card.appendChild(image);
      } else {
        var label = element('span', 'phq-shop__recipe-photo phq-shop__recipe-photo--missing', item.category === 'main' ? 'Main meal' : item.category === 'breakfast' ? 'Breakfast' : 'Pudding');
        label.setAttribute('aria-hidden', 'true');
        card.appendChild(label);
      }
      var copy = element('div', 'phq-shop__recipe-copy');
      copy.appendChild(element('h4', '', item.name));
      if (isIllustration) copy.appendChild(element('p', 'phq-photo-label', 'Packaging illustration'));
      copy.appendChild(element('p', '', quantity(item.quantity, 'case') + ' · ' + quantity(item.tins, 'tin') + ' · ' + quantity(item.servings, 'serving')));
      var recipe = catalogue.recipes.find(function (entry) { return entry.id === (item.recipeId || item.id); });
      if (recipe && recipe.storefrontEligible && recipe.productHandle) {
        var link = element('a', '', 'Ingredients & details');
        var productRoot = builderURL.pathname.split('/collections/')[0];
        link.href = productRoot + '/products/' + encodeURIComponent(recipe.productHandle);
        var detailsURL = new URL(link.href, window.location.href);
        detailsURL.searchParams.set('phq_draft', result.selectionToken);
        detailsURL.searchParams.set('phq_plan', result.planToken);
        link.href = detailsURL.href;
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', 'Ingredients and details for ' + item.name + ' (opens in a new tab)');
        copy.appendChild(link);
      }
      card.appendChild(copy);
      if (recipe && !recipe.storefrontEligible) {
        var detailsTemplate = Array.prototype.find.call(root.querySelectorAll('[data-phq-inline-recipe-template]'), function (template) { return template.getAttribute('data-phq-inline-recipe-template') === recipe.id; });
        if (detailsTemplate && detailsTemplate.content && detailsTemplate.content.querySelector('[data-phq-inline-recipe-details]')) {
          card.classList.add('phq-shop__recipe--with-details');
          copy.appendChild(detailsTemplate.content.cloneNode(true));
        }
      }
      addSwap(card,item,result);
      return card;
    }

    function render(result, request) {
      currentRequest=request;
      resetBar.hidden=!result.customised;
      setText('[data-phq-shopping-result-title]', result.customised?'Your customised food selection.':'Suggested food selection.');
      var people = quantity(result.people, 'person', 'people');
      setText('[data-phq-shopping-request-summary]', people + ' · ' + quantity(result.days, 'day'));
      setText('[data-phq-shopping-pattern-summary]', PATTERN_COPY[request.pattern] + (request.diet === 'vegetarian' ? '. Vegetarian recipes.' : '.'));
      setText('[data-phq-shopping-coverage-summary]', quantity(result.coverageDays, 'day') + ' for ' + people);
      setText('[data-phq-shopping-coverage-detail]', 'At your chosen serving pattern, using the included recipe portions.');
      var deficits=CATEGORIES.filter(function(k){return result.extraServings[k]<0;}).map(function(k){return number(-result.extraServings[k])+' '+k+' servings short';});
      setText('[data-phq-shopping-rounding]', deficits.length?'Below your requested plan: '+deficits.join('; ')+'. Change recipes or explicitly add a case to increase coverage.':'Quantities are complete six-tin recipe cases, so some servings may be left over.');
      root.querySelector('[data-phq-shopping-rounding]').classList.toggle('phq-shop__deficit',deficits.length>0);
      var totals = root.querySelector('[data-phq-shopping-serving-totals]');
      totals.replaceChildren();
      CATEGORIES.forEach(function (category) {
        var wanted = result.requestedServings[category] || 0;
        var supplied = result.suppliedServings[category] || 0;
        if (!wanted && !supplied) return;
        totals.appendChild(element('li', '', number(supplied) + ' ' + category + ' servings · ' + number(wanted) + ' requested'));
      });
      var recipes = root.querySelector('[data-phq-shopping-recipes]');
      recipes.replaceChildren();
      result.selection.forEach(function (item) { recipes.appendChild(recipeCard(item, result)); });
      setText('[data-phq-shopping-order-size]', quantity(result.cases, 'case') + ' · ' + quantity(result.tins, 'tin'));
      setText('[data-phq-shopping-price]', money(result.pricePence));
      var delivery = core.deliveryForSelection(result.build);
      setText('[data-phq-shopping-delivery]', delivery ? (delivery.deliveryPence ? money(delivery.deliveryPence) : 'Included') : '—');
      setText('[data-phq-shopping-total]', delivery ? money(delivery.totalPence) : '—');
      var link = new URL(builderURL.href);
      link.searchParams.set('phq', result.selectionToken);
      link.searchParams.set('phq_plan', result.planToken);
      link.hash = 'PrepareHQReserveEnquiryV1714';
      var enquiry = root.querySelector('[data-phq-shopping-enquiry]');
      enquiry.href = link.href;
      enquiry.textContent = result.journey === 'quote' ? 'Request a quote for this selection →' : 'Enquire about this selection →';
      var custom = new URL(link.href);
      custom.hash = '';
      root.querySelector('[data-phq-shopping-customise]').href = custom.href;
      try { window.sessionStorage.setItem(storedPlanKey, result.planToken); } catch (error) { /* Explicit links carry the plan. */ }
      var currentURL = new URL(window.location.href);
      currentURL.searchParams.set('phq_plan', result.planToken);
      currentURL.searchParams.set('phq_result', '1');
      currentURL.searchParams.delete('contact_posted');
      window.history.replaceState(window.history.state, '', currentURL.href);
      updateJourneyLinks(result.planToken);
      resultSection.hidden = false;
      status.textContent = 'Suggested selection ready: ' + quantity(result.cases, 'case') + ', ' + money(delivery ? delivery.totalPence : result.pricePence) + (delivery ? ' including estimated delivery.' : ' before delivery.');
      currentRecommendation = result;
      root.phqShoppingRecommendation = result;
      emit(result, request);
    }

    form.addEventListener('change', function () {
      clearOldSuccessFlag();
      currentRecommendation = null;
      root.phqShoppingRecommendation = null;
      resultSection.hidden = true;
      buy.hidden = true;
      buy.disabled = true;
      status.textContent = 'Choose Find my food to update your selection.';
      emit({ valid: false, errors: ['The shopping choices have changed. Calculate a new selection.'] }, readRequest());
      originalSuggestion=null;currentRequest=readRequest();saveMixHistory(false);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearOldSuccessFlag();
      var request = readRequest();
      var engine = window.PrepareHQShoppingEngine;
      if (!catalogue || !core || !engine) {
        status.textContent = 'The food finder could not load. You can still choose recipes in Build Your Own.';
        return;
      }
      var result;
      try { result = engine.recommend(catalogue, request); }
      catch (error) { result = { valid: false, errors: ['We could not calculate this selection. Please try Build Your Own.'] }; }
      if (!result.valid) {
        resultSection.hidden = true;
        buy.hidden = true;
        buy.disabled = true;
        status.textContent = result.errors.join(' ');
        emit(result, request);
        return;
      }
      originalSuggestion=result;render(result, request);saveMixHistory(false);
      root.dispatchEvent(new CustomEvent('phq:finder-completed', { bubbles: true, detail: { recommendation: result, request: request } }));
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      resultSection.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      root.querySelector('[data-phq-shopping-result-title]').focus({ preventScroll: true });
    });

    function restoreMix() {
      var url=new URL(window.location.href),tokens=url.searchParams.getAll('phq_mix');
      var planner=validatedPlannerToken(url);restorePlannerControls(planner);
      root.querySelector('[data-phq-shopping-vegetarian]').checked=url.searchParams.get('phq_diet')==='vegetarian';
      function clearResult(message){currentRecommendation=null;originalSuggestion=null;root.phqShoppingRecommendation=null;resultSection.hidden=true;buy.hidden=true;buy.disabled=true;status.textContent=message||'';emit({valid:false},readRequest());}
      if(!planner){clearResult(tokens.length?'That customised mix could not be restored. Choose Find my food to start again.':'');return;}
      if(!tokens.length){if(url.searchParams.get('phq_result')!=='1'){clearResult();return;}var suggested=window.PrepareHQShoppingEngine.recommend(catalogue,readRequest());if(suggested.valid){originalSuggestion=suggested;render(suggested,readRequest());}else clearResult(suggested.errors.join(' '));return;}
      var parsed=tokens.length===1?core.parseSelection(catalogue,tokens[0]):null;
      var q={};if(parsed&&parsed.valid)parsed.items.forEach(function(i){q[i.recipeId]=i.quantity;});
      if(!parsed||!parsed.valid){clearResult('That customised mix could not be restored. Choose Find my food to start again.');return;}
      var request=readRequest(),result=window.PrepareHQShoppingEngine.customise(catalogue,request,q);
      if(result.valid){originalSuggestion=window.PrepareHQShoppingEngine.recommend(catalogue,request);render(result,request);}else clearResult(result.errors.join(' '));
    }
    restoreMix();window.addEventListener('popstate',restoreMix);
    root.getShoppingSelection = function () { return currentRecommendation; };
  }

  function boot() { document.querySelectorAll('[data-phq-shopping]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) event.target.querySelectorAll('[data-phq-shopping]').forEach(initialise);
  });
})();
